// extracted by mini-css-extract-plugin
module.exports = {"videoEmbbed":"styles_videoEmbbed__5JzkA","videoEmbbed1":"styles_videoEmbbed1__t_EXv","playerHolder":"styles_playerHolder__GAAFi","holder":"styles_holder__EZXHD"};